import './App.css';
import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import PageNavigation from './PageNavigation';

function HomePage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Page Navigation Sidebar */}
      <PageNavigation />

      {/* Hero Section */}
      <section className="hero" id="home">
        <div className="hero-bg-animation"></div>
        <div className="container hero-content">
          <div className="hero-text">
            <span className="hero-badge">🌟 نحو مستقبل مشرق</span>
            <h1 className="hero-title">
              مركز <span className="gradient-text">آفاق</span>
              <br />
              لتدريب وتنمية الموارد البشرية
            </h1>
            <p className="hero-description">
              نؤمن بأن الاستثمار في الإنسان هو الطريق نحو النجاح والتميز.
              نقدم برامج تدريبية متخصصة تساعدك على تطوير مهاراتك وتحقيق أهدافك المهنية.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={() => navigate('/courses')}>استكشف الدورات 🚀</button>
              <button className="btn btn-secondary" onClick={() => navigate('/contact')}>تواصل معنا 💬</button>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">5000+</span>
                <span className="stat-label">متدرب</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">150+</span>
                <span className="stat-label">دورة تدريبية</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">مدرب محترف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">98%</span>
                <span className="stat-label">رضا العملاء</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <div className="floating-card card-1">
              <div className="card-icon">📚</div>
              <div className="card-text">
                <h4>دورات متنوعة</h4>
                <p>في جميع المجالات</p>
              </div>
            </div>
            <div className="floating-card card-2">
              <div className="card-icon">🏆</div>
              <div className="card-text">
                <h4>شهادات معتمدة</h4>
                <p>من جهات دولية</p>
              </div>
            </div>
            <div className="floating-card card-3">
              <div className="card-icon">👥</div>
              <div className="card-text">
                <h4>مدربين خبراء</h4>
                <p>ذوي كفاءة عالية</p>
              </div>
            </div>
            <div className="hero-shape"></div>
          </div>
        </div>
      </section>

      {/* Management Section */}
      <section className="management" id="about">
        <div className="management-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
        <div className="container">
          <div className="section-header">
            <span className="section-badge">✨ القيادة</span>
            <h2 className="section-title">فريق الإدارة</h2>
            <p className="section-description">
              بخبرة تمتد لسنوات طويلة في مجال التدريب وتنمية الموارد البشرية
            </p>
          </div>
          <div className="management-grid">
            <div className="management-card">
              <div className="card-bg"></div>
              <div className="card-avatar">
                <div className="avatar-circle">
                  <img src="/dr.talaat.jpg" alt="د. طلعت" className="avatar-image" />
                </div>
                <div className="avatar-decoration"></div>
              </div>
              <div className="card-content">
                <h3 className="card-name">د. طلعت آدم</h3>
                <p className="card-position">المدير العام</p>
                <p className="card-bio">
                  نسعى إلي تحقيق الاستدامة من خلال تقديم برامج تدريبية متنوعة في كافة التخصصات، كما نعمل جاهدين على تحقيق الريادة ليس فقط في دولة الإمارات العربية المتحدة، بل في منطقة الشرق الأوسط. نواكب التكنولوجيا والرقمنة في كافة معاملاتنا، كما نتميز بالرشاقة والمرونة المؤسسية في كل الأوقات لمواكبة التحديات والمتغيرات على الصعيد الداخلي والخارجي.
                </p>
              </div>
            </div>

            <div className="management-card">
              <div className="card-bg"></div>
              <div className="card-avatar">
                <div className="avatar-circle">
                  <img src="/zon.jpg" alt="أ. زينب" className="avatar-image" />
                </div>
                <div className="avatar-decoration"></div>
              </div>
              <div className="card-content">
                <h3 className="card-name">أ. زينب</h3>
                <p className="card-position">المدير التنفيذي للمركز</p>
                <p className="card-bio">
                  نجتهد في تقديم برامج تدريبية متنوعة لتحقيق الريادة في مجال اللغة الإنجليزية وعلوم الكمبيوتر والإدارة وإدارة الموارد البشرية، حققنا مراكز متقدمة في تقديم اختبارات الآيلتس، وشهد لنا القاصي والداني بالرقي في تقديم أفضل خدمات لتحقيق رضا العملاء وإسعاد المتعاملين. منذ عام 2005 وحتى الوقت الحالي، شعارنا الوضوح والشفافية والموضوعية في التعامل مع عملائنا، ونحرص على تحقيق أفضل استفادة لهم، من أجل تحقيق أعلى معدلات رفع كفاءة المتدربين وتحقيق التميز المؤسسي.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accreditations Section */}
      <section className="accreditations" id="accreditations">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">🏅 الاعتمادات</span>
            <h2 className="section-title">شركاء النجاح</h2>
            <p className="section-description accreditation-desc">
              نعمل في مركز آفاق وفق أفضل نظم الإدارة والتدريب، ونعزز علاقاتنا مع المؤسسات والمراكز والكليات الوطنية والدولية التي تمنح الاعتمادات والتراخيص والشهادات، وقد وفقنا في الحصول على مجموعة من هذه الاعتمادات المهمة، ونسعى دائمًا لتطوير أعمالنا وتعزيز شراكاتنا الخارجية لجلب المزيد من الاعتمادات.
            </p>
          </div>
          <div className="accreditations-grid">
            <div className="accreditation-item">
              <div className="accreditation-logo">
                <img src="/IELTS.png" alt="IELTS" />
              </div>
            </div>
            <div className="accreditation-item">
              <div className="accreditation-logo">
                <img src="/ICDL.jpg" alt="ICDL" />
              </div>
            </div>
            <div className="accreditation-item">
              <div className="accreditation-logo">
                <img src="/AA.png" alt="AA" />
              </div>
            </div>
            <div className="accreditation-item">
              <div className="accreditation-logo">
                <img src="/DubaiSignature.jpg" alt="Dubai Signature" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tests Section */}
      <section id="tests" className="tests">
        <div className="container">
          <h2 className="tests-title">الاختبارات المعتمدة</h2>
          <div className="tests-grid">
            <div className="test-item">
              <img src="/teofl.png" alt="TOEFL iBT" className="test-logo" />
            </div>
            <div className="test-item">
              <img src="/_793-446.jpg" alt="TOEFL ITP" className="test-logo" />
            </div>
            <div className="test-item">
              <img src="/IELTS.png" alt="IELTS" className="test-logo" />
            </div>
            <div className="test-item">
              <img src="/ICDL.jpg" alt="ICDL" className="test-logo" />
            </div>
          </div>
        </div>
      </section>

      {/* Divisions Section */}
      <section className="divisions" id="divisions">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">🏢 الأقسام</span>
            <h2 className="section-title">أقسام المؤسسة</h2>
            <p className="section-description">
              مركز آفاق للتعليم المستقبلي يطور من أقسامه ويفتتح أقسام جديدة بما ينسجم ويحقق أهدافه الحالية والمستقبلية، ويضم المركز عدة مراكز:
            </p>
          </div>
          <div className="divisions-grid">
            <div className="division-card">
              <div className="division-number">1</div>
              <h3 className="division-title">مركز "Language"</h3>
              <div className="division-decoration"></div>
            </div>
            <div className="division-card">
              <div className="division-number">2</div>
              <h3 className="division-title">مركـــز "iFuture"</h3>
              <div className="division-decoration"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="partners" id="partners">
        <div className="container">
          <div className="partners-header">
            <div className="partners-badge-wrapper">
              <span className="partners-badge">
                <span className="badge-icon">🤝</span>
                <span className="badge-text">شركاء النجاح</span>
              </span>
            </div>
            <h2 className="partners-title">تفخر بشراكاتنا المتميزة</h2>
            <p className="partners-description">نعمل مع أفضل المؤسسات والمراكز المحلية والدولية</p>
          </div>
          <div className="partners-grid">
            <div className="partners-track">
            <div className="partner-item">
              <img src="/pic1.jpg" alt="شريك 1" />
            </div>
            <div className="partner-item">
              <img src="/pic2.jpg" alt="شريك 2" />
            </div>
            <div className="partner-item">
              <img src="/pic3.jpg" alt="شريك 3" />
            </div>
            <div className="partner-item">
              <img src="/pic4.jpg" alt="شريك 4" />
            </div>
            <div className="partner-item">
              <img src="/pic5.jpg" alt="شريك 5" />
            </div>
            <div className="partner-item">
              <img src="/pic6.jpg" alt="شريك 6" />
            </div>
            <div className="partner-item">
              <img src="/pic7.jpg" alt="شريك 7" />
            </div>
            <div className="partner-item">
              <img src="/pic8.jpg" alt="شريك 8" />
            </div>
            <div className="partner-item">
              <img src="/pic9.jpg" alt="شريك 9" />
            </div>
            <div className="partner-item">
              <img src="/pic10.jpg" alt="شريك 10" />
            </div>
            <div className="partner-item">
              <img src="/pic11.jpg" alt="شريك 11" />
            </div>
            <div className="partner-item">
              <img src="/pic12.jpg" alt="شريك 12" />
            </div>
            <div className="partner-item">
              <img src="/pic13.jpg" alt="شريك 13" />
            </div>
            <div className="partner-item">
              <img src="/pic14.jpg" alt="شريك 14" />
            </div>
            <div className="partner-item">
              <img src="/pic15.jpg" alt="شريك 15" />
            </div>
            {/* Duplicate for seamless loop */}
            <div className="partner-item">
              <img src="/pic1.jpg" alt="شريك 1" />
            </div>
            <div className="partner-item">
              <img src="/pic2.jpg" alt="شريك 2" />
            </div>
            <div className="partner-item">
              <img src="/pic3.jpg" alt="شريك 3" />
            </div>
            <div className="partner-item">
              <img src="/pic4.jpg" alt="شريك 4" />
            </div>
            <div className="partner-item">
              <img src="/pic5.jpg" alt="شريك 5" />
            </div>
            <div className="partner-item">
              <img src="/pic6.jpg" alt="شريك 6" />
            </div>
            <div className="partner-item">
              <img src="/pic7.jpg" alt="شريك 7" />
            </div>
            <div className="partner-item">
              <img src="/pic8.jpg" alt="شريك 8" />
            </div>
            <div className="partner-item">
              <img src="/pic9.jpg" alt="شريك 9" />
            </div>
            <div className="partner-item">
              <img src="/pic10.jpg" alt="شريك 10" />
            </div>
            <div className="partner-item">
              <img src="/pic11.jpg" alt="شريك 11" />
            </div>
            <div className="partner-item">
              <img src="/pic12.jpg" alt="شريك 12" />
            </div>
            <div className="partner-item">
              <img src="/pic13.jpg" alt="شريك 13" />
            </div>
            <div className="partner-item">
              <img src="/pic14.jpg" alt="شريك 14" />
            </div>
            <div className="partner-item">
              <img src="/pic15.jpg" alt="شريك 15" />
            </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features" id="features">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">⭐ المميزات</span>
            <h2 className="section-title">لماذا مركز آفاق؟</h2>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>تدريب متخصص</h3>
              <p>برامج مصممة خصيصًا لتلبية احتياجات السوق</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💡</div>
              <h3>محتوى حديث</h3>
              <p>مواد تدريبية محدثة باستمرار</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🤝</div>
              <h3>دعم مستمر</h3>
              <p>فريق متاح دائمًا لمساعدتك</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>تعلم مرن</h3>
              <p>تدريب عن بُعد وحضوري</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏅</div>
              <h3>شهادات معتمدة</h3>
              <p>اعتمادات محلية ودولية</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>أسعار تنافسية</h3>
              <p>جودة عالية بأسعار مناسبة</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>هل أنت مستعد لبدء رحلة التطوير؟</h2>
            <p>انضم إلى آلاف المتدربين الذين طوروا مهاراتهم معنا</p>
            <button className="btn btn-primary btn-large" onClick={() => navigate('/courses')}>ابدأ الآن 🚀</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/aafaq-logo.png" alt="مركز آفاق" className="logo-image" />
                <div className="logo-text">
                  <h3>مركز آفاق</h3>
                  <p>للتدريب والموارد البشرية</p>
                </div>
              </div>
              <p className="footer-about">
                نسعى لتقديم أفضل البرامج التدريبية لتطوير الكوادر البشرية
                وتحقيق التميز في جميع المجالات.
              </p>
            </div>
            <div className="footer-section">
              <h4>روابط سريعة</h4>
              <ul className="footer-links">
                <li><Link to="/">الرئيسية</Link></li>
                <li><Link to="/about">من نحن</Link></li>
                <li><Link to="/trainers">المدربين</Link></li>
                <li><Link to="/courses">الدورات</Link></li>
                <li><Link to="/contact">تواصل معنا</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>تواصل معنا</h4>
              <ul className="footer-contact">
                <li>📧 <a href="mailto:info@aafaqcentre.com">info@aafaqcentre.com</a></li>
                <li>📱 <a href="tel:00971924330000">00971924330000</a></li>
                <li>💬 <a href="https://wa.me/971567953704">00971567953704</a></li>
                <li>💬 <a href="https://wa.me/971509803067">00971509803067</a></li>
                <li>📍 دبا الفجيرة - منطقة الراشدية</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>تابعنا</h4>
              <div className="social-links">
                <a href="https://wa.me/971567953704" target="_blank" rel="noopener noreferrer" className="social-link" title="واتساب">💬</a>
                <a href="mailto:info@aafaqcentre.com" className="social-link" title="البريد الإلكتروني">📧</a>
                <a href="tel:00971924330000" className="social-link" title="اتصل بنا">📱</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 مركز آفاق - جميع الحقوق محفوظة</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default HomePage;
